/*eslint-disable*/
import '../App.css';
import '../reset.css'
import '../seik-style.css'
import $ from 'jquery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import 'animate.css';

function Main() {     

    let news = [
        [`${process.env.PUBLIC_URL}/news1.jpg`, "게임 업데이트", "전략적 팀 전투 랭크 업데이트 - 리믹스 럼블 에디션", "곧 출시되는 리믹스 럼블에서는 전략적 팀 전투 랭크 등반을 평탄화하기 위해 에메랄드 티어가 추가되고 MMR 대상이 조정되는 등 몇 가지 사항이 변경됩니다!"],
        [`${process.env.PUBLIC_URL}/news2.jpg`, "미디어", "HEARTSTEEL - PARANOIA NG 모음", "가끔은 크게 실패할 때도 있습니다. HEARTSTEEL과 함께 PARANOIA 뮤직비디오의 뒷이야기를 살펴보세요."],
        [`${process.env.PUBLIC_URL}/news3.jpg`, "개발자 블로그", "전략적 팀 전투 개발자 일기: 리믹스 럼블", "신규 세트에서는, 플레이어 여러분이 바로 DJ입니다."]
    ];

    return (
        <div className='main' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/mainBg.png)` }}>
            <p className='title' style={{ left: "-70px", top: "74.5%" }}>-&nbsp;주목할 만한 소식&nbsp;-</p>
            <div className='vod_box'>
                <video controls={false} muted autoPlay loop style={{ zIndex: "-2", opacity: "0.7" }}>
                    <source src="https://www.leagueoflegends.com/static/hero-c35bd03ceaa5f919e98b20c905044a3d.webm" type="video/mp4" />
                </video>
                <video controls={false} muted autoPlay loop style={{ zIndex: "0", filter: "blur(50px)", position: "absolute", top: 0, left: 0 }}>
                    <source src="https://www.leagueoflegends.com/static/hero-c35bd03ceaa5f919e98b20c905044a3d.webm" type="video/mp4" />
                </video>
            </div>
            <div className='vod_box_f'>
                <video height="500px" controls={false} muted autoPlay loop style={{ objectFit: "cover", zIndex: "3" }}>
                    <source src="https://www.leagueoflegends.com/static/hero-c35bd03ceaa5f919e98b20c905044a3d.webm" type="video/mp4" />
                </video>
                <div className='main_border'></div>
                <div className='logo_box'>
                    <img style={{ cursor: "pointer" }} src={process.env.PUBLIC_URL + "/logo2.png"} alt='logo2'></img>
                    <div style={{ margin: "40px auto 0", position: "relative" }}>
                        <div className='play_box animate__animated animate__flipInX' style={{ animationDelay: '1.2s', }}></div>
                        <a className='play_border' href='' onMouseOver={() => { $(".main_border").stop().animate({ width: "100%", height: "100%" }) }}
                            onMouseOut={() => { $(".main_border").stop().animate({ width: "102%", height: "104%" }) }}>무료로 플레이하기</a>
                    </div>
                </div>
            </div>
            <div className='between new_div'>
                {
                    news.map(function (newsItem, index) {
                        return (
                            <div className='news_box animate__animated animate__zoomIn' key={index} style={{ marginBottom: "18px" }}>
                                <div
                                    id='newsbox'
                                    className='animate__animated animate__fadeIn'
                                    onMouseOver={(e) => {
                                        const target = e.currentTarget;
                                        $(target).children("#news_img").width("34%")
                                    }}

                                    onMouseOut={(e) => {
                                        const target = e.currentTarget;
                                        $(target).children("#news_img").width("32%")
                                    }}
                                >
                                    <div id='news_img' style={{ transition: "width 0.5s ease", backgroundImage: `url(${newsItem[0]})`, backgroundSize: "cover", backgroundPosition: "center" }}></div>
                                    <div id='news_txt'>
                                        <p>{newsItem[1]}</p>
                                        <h2>{newsItem[2]}</h2>
                                        <h3>{newsItem[3]}</h3>
                                    </div>
                                </div>
                            </div>

                        )
                    })
                }
            </div>
            <a href='' className='a'>모두보기&nbsp;&nbsp;&nbsp;<span><FontAwesomeIcon icon={faArrowRight} /></span></a>
        </div>
    )
}

export default Main